module.exports = __webpack_public_path__ + "d860f80cda05312f7bc22150dd3c28af.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/img/homePage/eight_gragon_bg.png
// module id = 1116
// module chunks = 0